import React from 'react';
import { Avatar, AvatarProps, Box, BoxProps } from '@mui/material';
import { useAuthenticatedMediaUrl } from '../../utils/profileMediaUrl';

interface ProfileMediaAvatarProps extends AvatarProps {
  mediaUrl?: string | null;
}

export const ProfileMediaAvatar: React.FC<ProfileMediaAvatarProps> = ({
  mediaUrl,
  src,
  ...rest
}) => {
  const resolvedSrc = useAuthenticatedMediaUrl(mediaUrl ?? (typeof src === 'string' ? src : undefined));
  return <Avatar {...rest} src={resolvedSrc} />;
};

interface ProfileCoverBannerProps extends BoxProps {
  mediaUrl?: string | null;
  minHeight?: number;
}

export const ProfileCoverBanner: React.FC<ProfileCoverBannerProps> = ({
  mediaUrl,
  minHeight = 160,
  sx,
  ...rest
}) => {
  const resolvedSrc = useAuthenticatedMediaUrl(mediaUrl);
  if (!resolvedSrc) {
    return null;
  }

  return (
    <Box
      {...rest}
      sx={{
        minHeight,
        backgroundImage: `url(${resolvedSrc})`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        borderRadius: 1,
        ...sx,
      }}
    />
  );
};
